/**
 * Created by jacmai on 2/27/2017.
 */

define([
  "marionette",
  "modules/actions/actionGroup/actionGroupInfo/template/actionGroupInfoTemplate.html",
], function (Marionette, ActionGroupInfoTemplate) {
  var ActionGroupInfoView = {};

  ActionGroupInfoView.actionGroupInfoView = Marionette.ItemView.extend({
    template: ActionGroupInfoTemplate,
    nameError: function (errorMessage) {
      this.$el
        .find("#actionGroupNameText")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    textboxes: {
      "#actionGroupNameText": {
        enableSelector: "#actionGroupName",
        modelAttribute: "name",
        placeholder: "actions.group.name",
        textArea: false,
      },
      "#actionGroupDescText": {
        enableSelector: "#actionGroupDesc",
        modelAttribute: "description",
        placeholder: "actions.group.description",
        textArea: true,
      },
    },
    triggers: {
      "click #deleteGroup": "delete:group",
    },
  });

  return ActionGroupInfoView;
});
